import { render, staticRenderFns } from "./DateInputForm.vue?vue&type=template&id=65fa0d3e&scoped=true"
import script from "./DateInputForm.vue?vue&type=script&lang=js"
export * from "./DateInputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa0d3e",
  null
  
)

export default component.exports